(function BlogPostsCreateComment($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/BlogPosts/index/', function onload() {
			$(".blog-excerpt").shorten({
				showChars: 300,
				moreText : "See More", 
				lessText : "Less", 
			});
			$(".blog-body").shorten({
				showChars: 300,
				moreText : "See More", 
				lessText : "Less", 
			});
		});
	});
}(jQuery, window.Adzuki || {}));